export const correctDate = (createdAt) => {
    const date = new Date(createdAt)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const hour = date.getHours()
    const minutes = date.getMinutes()
    return `${day >= 10 ? day : `0${day}`}/${month >= 10 ? month : `0${month}`}/${year} às ${hour >= 10 ? hour : `0${hour}`}:${minutes >= 10 ? minutes : `0${minutes}`}`
}